import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IRetailerPageData } from "@faire/web-api--source/faire/home_resource/IRetailerPageData";

export const getModalData = (): IRetailerPageData.IModalData | undefined => {
  return getGlobalProperty("modalData");
};
